// extracted by mini-css-extract-plugin
export default {"pages":"Paging_pages__7+K8V","active":"Paging_active__UCmI9"};